import axios from "axios";
import { handleAuthFailure } from "../service/session";

// Create instance called instance
const instance = axios.create({
  baseURL: process.env.API_URL,
  headers: { Accept: "application/json" },
});

// A 401/403 means the adminToken has expired or been rejected — end the session and redirect to
// login rather than letting the raw error bubble into a broken-looking screen.
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    handleAuthFailure(error?.response?.status);
    return Promise.reject(error);
  }
);

export const getData = async (api: string) => {
  if(sessionStorage.getItem('adminToken')) {
    instance.defaults.headers.common['Authorization'] = sessionStorage.getItem('adminToken')!;
  }
  return await instance({ method: "GET", url: api });
};

export const postData = async (api: string, data: string) => {
  if(sessionStorage.getItem('adminToken')) {
    instance.defaults.headers.common['auth-token'] =  "Bearer " + sessionStorage.getItem('adminToken');
  }
  
  return await instance({ method: "POST", url: api, data: data,  });
};